import React from 'react'
import InputBox from 'containers/common/components/InputBox'

class HomeWorth extends React.Component {
  render() {
    const {
      errorMessage,
      value,
      onChange,
      disabled,
    } = this.props

    return(
      <div>
        <div className='mb-3' />
        <div className='grey smaller mb-2'>
          How much do you think your current home is worth?
        </div>
        <div className='form-group'>
          <InputBox
            disabled={ disabled }
            id={ 'currentHomeWorth' }
            errorMessage={ errorMessage }
            onChange={ (e) => { onChange(e.currentTarget.value) } }
            value={ value }
            displayMonthly={ false }
          />
        </div>
      </div>
    )
  }
}

export default HomeWorth;
